'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const CollapsibleContext = createContext(void 0);
CollapsibleContext.displayName = 'CollapsibleContext';
function useCollapsibleContext() {
    return useNonNullishContext(CollapsibleContext);
}

export { CollapsibleContext, useCollapsibleContext };
